export const checkIfOnlyOneOptionHasValue = (dataArray: number[]) => {
  return dataArray.filter((item: number) => item !== 0).length === 1;
};

export const checkIfPositiveNumber = (stringNumber: string | number) =>
  +stringNumber >= 0;

export const generateNumberStringWithPlusOrMinus = (
  number: string | number, //formatted number
  rawNumber: string | number
) => {
  return +rawNumber >= 0 ? `+${number}` : `${number}`;
};

export const generateBoldTickElement = (monthsArray: string[] | undefined) =>
  monthsArray?.map((month: string, index: number) =>
    index === monthsArray.length - 2 ? 600 : 400
  );
export const checkIfArrayHasAnyValues = (array: number[] | undefined) =>
  array?.some((item: number) => item !== 0);
